import * as React from "react";
import * as moment from "moment";
import {Renewal, PREMIUM_TYPE_ANNUAL} from "@ferry/journey-services";
import {InfoBanner} from "@ferry/portal-core";


interface IProps {
    renewalProposal?: Renewal;
    product: React.ReactNode;
    productContent: React.ReactNode;
    monthlyInstalmentsAllowed: boolean;
}

// Banner in header to inform that policy will be renewed
export class PolicyWillBeRenewedBanner extends React.Component<IProps> {
    constructor(props: any) {
        super(props);
    }

    public render() {
        const pendingRenewalDate: moment.Moment = moment.utc(this.props.renewalProposal?.headerInfo.startDate, moment.ISO_8601);

        return (
            <InfoBanner wording={
                <>
                    Rest easy - your {this.props.product} Insurance policy for{' '}
                    <strong>{this.props.productContent} is scheduled to renew on {pendingRenewalDate.format("D MMMM YYYY, 00:00")}.</strong>{' '}
                    No payment will be taken until then.
                    {this.props.renewalProposal?.factors.premiumType === PREMIUM_TYPE_ANNUAL && this.props.monthlyInstalmentsAllowed && <p>Monthly instalments are available at additional cost.</p>}
                </>
            }/>
        )
    }
}
